// ═══════════════════════════════════════
// CAIO Agents — 색상·에이전트·카테고리 공유 모듈
// 모든 컴포넌트에서 import하여 사용
// CSS 변수 참조: App.css :root
// ═══════════════════════════════════════

export const AGENTS = [
  { id: 'ceo',     name: '블오',   role: 'CEO',       team: '경영진', color: 'var(--agent-ceo)',     portrait: '/assets/agent_ceo.png',     bubbles: ['지시 전달중', '보고 확인중', '전략 검토중'] },
  { id: 'sage',    name: '현자',   role: '멘토',       team: '경영진', color: 'var(--agent-sage)',    portrait: '/assets/agent_sage.png',    bubbles: ['리스크 분석', '타이밍 판단', '전략 조언'] },
  { id: 'dash',    name: '대시',   role: '데이터',     team: '경영진', color: 'var(--agent-dash)',    portrait: '/assets/agent_dash.png',    bubbles: ['KPI 분석중', '매출 리포트', '성과 추적'] },
  { id: 'checker', name: '체커',   role: 'QA검수',    team: '경영진', color: 'var(--agent-checker)', portrait: '/assets/agent_checker.png', bubbles: ['톤 검수중', '팩트체크', '규칙 확인'] },
  { id: 'trendy',  name: '트렌디', role: '트렌드',     team: '경영진', color: 'var(--agent-trendy)',  portrait: '/assets/agent_trendy.png',  bubbles: ['네이버 변화 감지', '알고리즘 분석', '트렌드 리포트'] },
  { id: 'thread',  name: '쓰레디', role: '스레드',     team: '그로스', color: 'var(--agent-thread)',  portrait: '/assets/agent_thread.png',  bubbles: ['A트랙 정보글', 'B트랙 세계관', '글 작성중…'] },
  { id: 'cafe',    name: '카페로', role: '카페글',     team: '그로스', color: 'var(--agent-cafe)',    portrait: '/assets/agent_cafe.png',    bubbles: ['기본트랙 작성', '프리미엄 심화', '카페글 발행'] },
  { id: 'multi',   name: '멀티',   role: '멀티채널',   team: '그로스', color: 'var(--agent-multi)',   portrait: '/assets/agent_multi.png',   bubbles: ['인스타 변환', '숏폼 대본', '포맷 변환중'] },
  { id: 'bravo',   name: '브라보', role: '성과홍보',   team: '그로스', color: 'var(--agent-bravo)',   portrait: '/assets/agent_bravo.png',   bubbles: ['후기 수집중', '홍보 소재', '성과 정리'] },
  { id: 'ddogi',   name: '또기',   role: '단톡방',     team: '운영',   color: 'var(--agent-ddogi)',   portrait: '/assets/agent_ddogi.png',   bubbles: ['공지 발송중', '리마인드', '크루 관리'] },
  { id: 'reply',   name: '리플',   role: 'CS케어',    team: '운영',   color: 'var(--agent-reply)',   portrait: '/assets/agent_reply.png',   bubbles: ['문의 대응중', '리뷰 답변', '온보딩 안내'] },
  { id: 'booker',  name: '북커',   role: '콘텐츠',     team: '콘텐츠', color: 'var(--agent-booker)',  portrait: '/assets/agent_booker.png',  bubbles: ['전자책 작성', '강의안 제작', '뉴스레터'] },
  { id: 'healthy', name: '헬시',   role: '건강블로그', team: '자동화', color: 'var(--agent-healthy)', portrait: '/assets/agent_healthy.png', bubbles: ['크롤링 완료!', 'AI 글작성', 'Notion 저장'] },
  { id: 'spo',     name: '스포',   role: '스포츠',     team: '자동화', color: 'var(--agent-spo)',     portrait: '/assets/agent_spo.png',     bubbles: ['뉴스 수집중', '텔레그램 전송', '8시 크롤링'] },
  { id: 'closer',  name: '클로저', role: '세일즈',     team: '세일즈', color: 'var(--agent-closer)',  portrait: '/assets/agent_closer.png',  bubbles: ['전환율 분석', '상품 최적화', 'CTA 테스트'] },
  { id: 'pixel',   name: '픽셀',   role: '디자인',     team: '디자인', color: 'var(--agent-pixel)',   portrait: '/assets/agent_pixel.png',   bubbles: ['썸네일 작업', '카드뉴스', '상세페이지'] },
];

export const AGENT_MAP = Object.fromEntries(AGENTS.map(a => [a.id, a]));

export const STATUS_COLOR = {
  '크롤링 완료': 'var(--status-crawl)',
  '글 작성 완료': 'var(--status-write)',
  '발행 완료':   'var(--status-publish)',
  '완료':       'var(--status-done)',
  '미완료':     'var(--status-pending)',
};

export const CATEGORY_COLOR = {
  '아카데미':  'var(--cat-academy)',
  '운영':     'var(--cat-ops)',
  '스레드':   'var(--cat-thread)',
  '블다챌':   'var(--cat-challenge)',
  'VIP':     'var(--cat-vip)',
  '교회':     'var(--cat-church)',
  '아카데디': 'var(--cat-academy)',
  '개인':     'var(--cat-personal)',
  '기타':     'var(--cat-ops)',
};

export const CHATROOM_COLOR = {
  '광이블로그':  'var(--chat-blog)',
  '블오직접':   'var(--chat-direct)',
  '단톡방공지': 'var(--chat-group)',
  '스레드글':   'var(--chat-thread)',
  '카페글':     'var(--chat-cafe)',
  '상세페이지': 'var(--chat-page)',
  '제목짓기학원':'var(--cat-church)',
};

export const PRIORITY_COLOR = {
  '🔴 높음': 'var(--red)',
  '🟡 보통': 'var(--orange)',
};

export const PIPE_COLORS = {
  '크롤링 완료': 'var(--status-crawl)',
  '글 작성 완료': 'var(--status-write)',
  '발행 완료':   'var(--status-publish)',
  '없음':       'var(--cat-ops)',
};

// API 소스 → 관여 에이전트 목록
export const SOURCE_AGENTS = {
  'agent-chain':      ['dash', 'closer', 'checker', 'sage'],
  'agent-brainstorm': ['ceo', 'sage', 'dash'],
  'agent-plan':       ['ceo', 'sage'],
  'health-write':     ['healthy'],
  'keyword-analyze':  ['trendy'],
  'keyword-monitor':  ['trendy'],
};

// 카테고리 → 에이전트 매핑
export const CATEGORY_AGENT = {
  '아카데미': 'booker', '스레드': 'thread', '운영': 'ddogi',
  'VIP': 'closer', '블다챌': 'bravo', '교회': 'ddogi', '아카데디': 'booker',
};

// 채팅방 → 에이전트 매핑
export const CHATROOM_AGENT = {
  '단톡방공지': 'ddogi', '스레드글': 'thread', '카페글': 'cafe',
  '상세페이지': 'pixel', '블오직접': 'ceo', '광이블로그': 'ceo', '제목짓기학원': 'booker',
};
